export default __webpack_public_path__ + "static/media/jacket-4.d8fae99b.jpg";